var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useRef } from 'react';
import { useUpdateSync } from '../useUpdateSync/useUpdateSync';
export const useUpdatedRef = (value, comparator) => {
    _react_refresh_temp_1();
    const ref = useRef(value);
    useUpdateSync(() => {
        ref.current = value;
    }, value, comparator);
    return ref;
};
_react_refresh_temp_1(useUpdatedRef, "gpfsfXOrW9O5g987PQd/2TMFkKg=", false, () => [useUpdateSync]);
